import { createSelector } from '@ngrx/store';

import { CoreState } from '../reducers';
import { getIsMobile, getIsInternetExplorer, getKeepUsingInternetExplorer } from '../reducers/browser.reducer';

export const getBrowserState = (state: CoreState) => state.browser;
export const getBrowserIsMobile = createSelector(getBrowserState, getIsMobile);
export const getBrowserIsInternetExplorer = createSelector(getBrowserState, getIsInternetExplorer);
export const getBrowserKeepUsingInternetExplorer = createSelector(getBrowserState, getKeepUsingInternetExplorer);
